import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {GRAY, GRAY_DARKER} from 'ui-library/Colors';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';

import * as BulkAssemblyConstants from '../BulkAssemblyConstants';

interface EndpointTypeDropdownProps {
  getEndpoint: (index: number) => BulkAssemblyConstants.Endpoint;
  handleEndpointTypeChange: (index: number, type: BulkAssemblyConstants.EndpointType) => void;
  index: number;
}

export default function EndpointTypeDropdown({
  getEndpoint,
  handleEndpointTypeChange,
  index,
}: EndpointTypeDropdownProps): JSX.Element {
  return (
    <SelectDropdown
      displayName={BulkAssemblyConstants.ENDPOINT_TYPE_DISPLAY_NAMES[getEndpoint(index).type]}
      menu={
        <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.FULL}>
          {(Object.keys(BulkAssemblyConstants.EndpointType) as Array<BulkAssemblyConstants.EndpointType>)
            .filter(
              (endpointType) =>
                endpointType !== BulkAssemblyConstants.EndpointType.GIBSON ||
                BenchlingConfig.MOLBIO_ENABLE_BULK_GIBSON_ASSEMBLY
            )
            .map((endpointType) => (
              <Option
                key={endpointType}
                value={endpointType}
                onSelect={(type: BulkAssemblyConstants.EndpointType) => {
                  handleEndpointTypeChange(index, type);
                }}
                dataTestAttrs={{component: 'EndpointTypeDropdown', key: `${endpointType}`}}
              >
                <div className={css(styles.optionContainer)}>
                  <div className={css(styles.icon)}>
                    <BenchlingIcon icon={BulkAssemblyConstants.ENDPOINT_TYPE_ICONS[endpointType]} />
                  </div>
                  <div className={css(styles.text)}>
                    <p className={css(styles.header)}>
                      {BulkAssemblyConstants.ENDPOINT_TYPE_DISPLAY_NAMES[endpointType]}
                    </p>
                    <p className={css(styles.description)}>
                      {BulkAssemblyConstants.ENDPOINT_TYPE_DESCRIPTIONS[endpointType]}
                    </p>
                  </div>
                </div>
              </Option>
            ))}
        </Menu>
      }
    />
  );
}

const styles = StyleSheet.create({
  optionContainer: {
    display: 'flex',
  },
  icon: {
    flex: 1,
    verticalAlign: 'middle',
    margin: 'auto',
    color: GRAY_DARKER,
  },
  header: {
    fontWeight: 800,
    marginBottom: '0px',
  },
  description: {
    color: GRAY,
    marginBottom: '0px',
  },
  text: {
    flex: 10,
    marginLeft: '16px',
  },
});
